export default __webpack_public_path__ + "static/media/3.a879357d.jpg";